export const GET_USER = "GET_USER";
export const FIND_PRODUCT = "FIND_PRODUCT";
export const DELETE_CART = "DELETE_CART";
export const CLEAN_CART = "CLEAN_CART";
export const API_URL = "https://shopjsonserver-production.up.railway.app";

// http://localhost:3000
